export * from './businessIntelligence.service';
import { BusinessIntelligenceService } from './businessIntelligence.service';
export * from './businessIntelligence.serviceInterface';
export * from './client.service';
import { ClientService } from './client.service';
export * from './client.serviceInterface';
export * from './dashboard.service';
import { DashboardService } from './dashboard.service';
export * from './dashboard.serviceInterface';
export * from './module.service';
import { ModuleService } from './module.service';
export * from './module.serviceInterface';
export * from './organization.service';
import { OrganizationService } from './organization.service';
export * from './organization.serviceInterface';
export * from './registration.service';
import { RegistrationService } from './registration.service';
export * from './registration.serviceInterface';
export * from './role.service';
import { RoleService } from './role.service';
export * from './role.serviceInterface';
export * from './user.service';
import { UserService } from './user.service';
export * from './user.serviceInterface';
export const APIS = [BusinessIntelligenceService, ClientService, DashboardService, ModuleService, OrganizationService, RegistrationService, RoleService, UserService];
